/* src/app/user-default/states-update-list/states-update-list.component.scss */
/*# sourceMappingURL=states-update-list.component-4CEVGPZT.css.map */
